module.exports = __webpack_public_path__ + "staticcomp/img/top.cbee088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/9/top.jpg
// module id = YaXy
// module chunks = 39